import { useEffect, useState, useRef } from 'react';
import toast from 'react-hot-toast';

import BlocoEItensFormularioAcompanhamento from '../componentes/BlocoEItensFormularioAcompanhamento';
import BarraBuscaComTodasUnidades from '../componentes/BarraBuscaComTodasUnidades';
import SelectInstrumento from '../componentes/SelectInstrumento';
import AssinaturasFormularioAcompanhamento from '../componentes/AssinaturasFormularioAcompanhamento';
import TituloSessao from '../componentes/TituloSessao';

import Flatpickr from "react-flatpickr";
import { Portuguese } from "flatpickr/dist/l10n/pt.js";

import TelaInformativa from './TelaInformativa';

import {
    servGetAllOpcaoRespostaFormularioAcompanhamento,
    servPostFormularioAcompanhamento,
    servVerificaMesEnvio,
    servVerificaDuplicidade
}
    from '../servicos/servicosEmRotasPrivadas/formulario_acompanhamento';

import { servGetBlocoAndItensByEstabelecimendoId } from '../servicos/bloco_item_formulario';
import { servDownloadFormularioAcompanhamento } from '../servicos/servicosEmRotasPrivadas/download';

import DataMes from '../componentes/DataMes';
import smartToast from '../util/smart_toast';

function CriaFormularioAcompanhamento() {

    console.log('###Iniciando CriaFormularioAcompanhamento###');

    const [exibirTelaInformativa, setExibeTelaInformativa] = useState(false)
    const [blocoItensFormulario, setBlocoItensFormulario] = useState(null)
    const [estabelecimento, setEstabelecimento] = useState(null)
    const [dataVisita, setDataVisita] = useState('')
    const [mesCompetencia, setMesCompetencia] = useState('')
    const [envioValido, setEnvioValido] = useState(null)
    const [opcoesRespostas, setOpcoesRespostas] = useState(null)
    // Me pediram pra fixar esses dois ids abaixo, no dia que tiver mais de uma opcao nao eh
    // mais necessario fazer isso
    const [objetoId] = useState(1)
    const [instrumentoId, setInstrumentoId] = useState(1)

    const itensDoFormularioRespondidosRef = useRef([]);

    const novoObjAssinatura = { 'nomeCompleto': null, 'matricula': null, 'setor': null }
    const [assinaturas, setAssinaturas] = useState([novoObjAssinatura]);

    // verifica data e impoe limites
    useEffect(() => {

        const verificaMesEnvio = async () => {
            try {

                await smartToast(
                    servVerificaMesEnvio(estabelecimento.id, mesCompetencia),
                    {
                        loadingMessage: 'Verificando se mês de envio é válido...',
                        apenasLoading: true
                    },
                );

                return true

            } catch (erro) {
                toast.error(erro.message)
                console.error(erro);
                return false
            }
        }

        const verificaDuplicidade = async () => {
            try {

                await smartToast(
                    servVerificaDuplicidade(estabelecimento.id, mesCompetencia),
                    {
                        loadingMessage: 'Verificando se a unidade já enviou relatório no mês selecionado...',
                        apenasLoading: true
                    },
                );

                return true

            } catch (erro) {
                console.error(erro);
                toast.error(erro.message)
                return false
            }
        }

        const validacaoFinal = async () => {

            const [validaDuplicidade, validaMes] = await Promise.all([
                verificaDuplicidade(),
                verificaMesEnvio()
            ])

            if (validaDuplicidade && validaMes) {

                itensDoFormularioRespondidosRef.current = []
                setBlocoItensFormulario(null)

                try {

                    const itensFormularioDaApi = await smartToast(
                        servGetBlocoAndItensByEstabelecimendoId(estabelecimento.id),
                        {
                            loadingMessage: 'Buscando perguntas relacionadas a unidade selecionada...',
                            apenasLoading: true
                        },
                    );

                    setBlocoItensFormulario(itensFormularioDaApi);
                    console.log(blocoItensFormulario);

                } catch (erro) {
                    console.log(erro);
                    toast.error(erro.message)
                }

                // Validei o estabelecimento, o mês, busquei as perguntas, agora posso colocar as informações na tela.
                setEnvioValido(true)

            } else {

                // Alguma validação não passou, limpando tela para impedir qualquer tentativa de envio
                setEnvioValido(false)

            }
        }

        if (mesCompetencia && estabelecimento) validacaoFinal()

    }, [mesCompetencia, estabelecimento]);

    // Busca opções de resposta dos itens (perguntas)
    useEffect(() => {

        const getAllOpcaoRespostaFormularioAcompanhamento = async () => {
            try {
                const respostasDaApi = await servGetAllOpcaoRespostaFormularioAcompanhamento()
                const idNaoSeAplica = respostasDaApi.data.find(resposta => resposta.resposta.includes('N.A'))?.id;
                setOpcoesRespostas({
                    respostas: respostasDaApi.data,
                    idNaoSeAplica: idNaoSeAplica
                })
            } catch (erro) {
                toast.error(erro.message)
                console.error(erro);
            }
        }

        getAllOpcaoRespostaFormularioAcompanhamento()

    }, []);

    const adicionaItemFormulario = (listaComNovosItens) => {

        listaComNovosItens.forEach(novoItem => {
            const index = itensDoFormularioRespondidosRef.current.findIndex(
                itemBuscado => novoItem.modeloItemFormularioAcompanhamentoId === itemBuscado.modeloItemFormularioAcompanhamentoId
            );

            if (index !== -1) {
                itensDoFormularioRespondidosRef.current[index] = novoItem;
            } else {
                itensDoFormularioRespondidosRef.current.push(novoItem);
            }
        })
    }

    const addAssinatura = () => {
        if (assinaturas.length >= 3) {
            toast.error('Você atingiu o limite de três assinaturas')
            return;
        }
        // const novaAssinatura = { 'nomeCompleto': '', 'matricula': '', 'setor': '' }
        setAssinaturas([...assinaturas, novoObjAssinatura])
    }

    const removeAssinatura = (index) => {
        if (assinaturas.length <= 1) {
            toast.error('Ao menos uma assinatura é necessária')
            return;
        }
        const data = [...assinaturas];
        data.splice(index, 1)
        setAssinaturas(data)
    }

    const coletaAssinatura = (index, key, value) => {
        let prevList = [...assinaturas];
        prevList[index][key] = value;
        setAssinaturas(prevList);
    }

    async function handlerSubmit(event) {

        event.preventDefault();

        if (!estabelecimento) {
            toast.error('Selecione um estabelecimento')
            return;
        }

        if (!dataVisita) {
            toast.error('Selecione a Data de Visita')
            return;
        }

        const formData = new FormData(event.target);
        const resumoFragilidadesDetectadas = formData.get('resumoFragilidadesDetectadas');

        const formularioAcompanhamento = {
            'estabelecimentoId': estabelecimento.id,
            'dataVisita': dataVisita,
            'mesCompetencia': mesCompetencia,
            'instrumentoId': instrumentoId,
            'objetoId': objetoId,
            'resumoFragilidadesDetectadas': resumoFragilidadesDetectadas,
            'assinaturas': assinaturas,
            'itensDoFormulario': itensDoFormularioRespondidosRef.current
        };

        try {

            const responseCriacaoFormulario = await smartToast(
                servPostFormularioAcompanhamento(formularioAcompanhamento),
                {
                    loadingMessage: 'Criando Relatório...',
                    apenasLoading: false
                },
            );

            try {
                servDownloadFormularioAcompanhamento(responseCriacaoFormulario.data.formularioAcompanhamentoId)
            } catch (error) {
                console.log(error);
                toast.error('Houve um problema ao baixar o formulário.')
            }

            setExibeTelaInformativa(true)

        } catch (erro) {
            console.error(erro);
            toast.error(erro.message)
        }

    }

    if (exibirTelaInformativa) {
        return <TelaInformativa cabecalho='Formulário criado com sucesso'
            mensagem='Clique no botão abaixo para retornar à tela de cadastro de Formulários'
            pathRedirect={null}
            buttonMessage='Voltar'
            urlExterna={false} />;
    }

    return (

        <div className='container-fluid p-3'>
            <TituloSessao titulo='Relatório de Acompanhamento das unidades' barraDecorativa={false} centralizaTitulo={true} />
            <form className='d-flex flex-column gap-3' onSubmit={handlerSubmit}>
                <div className='div-flex-com-borda container p-3'>
                    <div className='d-flex gap-3'>

                        <div className='d-flex gap-2 align-items-center'>
                            <label htmlFor='dataVisita' className="text-nowrap">Data da visita à unidade</label>
                            <Flatpickr
                                id='dataVisita'
                                value={dataVisita}
                                onChange={([selectedDate]) => setDataVisita(selectedDate)}
                                options={{
                                    dateFormat: "d/m/Y",
                                    locale: Portuguese
                                }}
                                className="form-control"
                                required
                            />
                        </div>

                        <div className='d-flex gap-2 align-items-center'>
                            <label htmlFor='mesCompetencia' className="text-nowrap">Mês de competência</label>
                            <DataMes
                                id='mesCompetencia'
                                mes={mesCompetencia}
                                setData={setMesCompetencia}
                                getUltimoDia={false}
                            />
                        </div>

                        <div className='d-flex gap-2 align-items-center'>
                            <label htmlFor='selectInstrumento' className="text-nowrap">Número do instrumento</label>
                            <SelectInstrumento
                                id='selectInstrumento'
                                setInstrumento={setInstrumentoId}
                                label='Número do instrumento'
                            />
                        </div>

                    </div>
                    <div className='w-100'>
                        <BarraBuscaComTodasUnidades
                            setEstabelecimento={setEstabelecimento}
                            somenteAtivos={true}
                            enviaRelatorioAcompanhamento={true}
                        />
                    </div>
                </div>
                {estabelecimento && envioValido && mesCompetencia ? (
                    <div className='d-flex flex-column'>
                        <p className='m-1'>Este documento destina-se ao registro da visita "in loco" à unidade de saúde, afim de monitorar a execução da parceria, objeto do contrato. Cada item deverá ser identificado como SIM, NÃO E PARCIAL (N.A. quando não pertinente ao objeto). Utilizar o campo de OBSERVAÇÕES para fazer considerações sobre as fragilidades apontadas, se necessário, complementados com os ANEXOS DE APOIO.</p>
                        {blocoItensFormulario && opcoesRespostas &&
                            blocoItensFormulario.map((blocoItem) => (
                                <BlocoEItensFormularioAcompanhamento
                                    key={blocoItem.id}
                                    blocoItem={blocoItem}
                                    respostas={opcoesRespostas.respostas}
                                    adicionaItemFormulario={adicionaItemFormulario}
                                />
                            ))}
                        <div className='container-fluid d-flex flex-column gap-2 mt-2'>
                            <p className='m-1'>*344/1998 estabelece que os medicamentos e substâncias sob controle especial devem ser guardados sob chave ou outro dispositivo que ofereça segurança, portanto, independentemente da solução utilizada pelo estabelecimento, a mesma não pode permitir o acesso aos produtos/ insumos por pessoas não autorizadas (acesso restrito)						</p>
                            <p className='m-1'>**RDC nº 2/2010 determina que a Unidade deve ter um planejamento de manutenção e o monitoramento do desempenho de equipamentos ativos, desenvolvido por técnicos. 						</p>
                            <div className='w-100'>
                                <p className='m-1'>RESUMO DAS FRAGILIDADES DETECTADAS - Apontar considerando o observado nos itens acima</p>
                                <textarea className="w-100" name="resumoFragilidadesDetectadas" maxLength={600} />
                            </div>
                            <div>
                                <AssinaturasFormularioAcompanhamento assinaturas={assinaturas}
                                    coletaAssinatura={coletaAssinatura}
                                    addAssinatura={addAssinatura}
                                    removeAssinatura={removeAssinatura}
                                />
                            </div>
                        </div>
                        <button className='btn btn-primary mt-2' type='submit'>Enviar</button>
                    </div>
                )
                    :
                    (<div className='d-flex justify-content-center'>
                        <p className='fw-bold mt-3'> ** Selecione um Estabelecimento/Unidade e o Mês de Competência para listar as perguntas ** </p>
                    </div>)
                }
            </form>
        </div>
    );
}

export default CriaFormularioAcompanhamento
